import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ user, children }) => {
  if (!user?.logged_in && !user.hasOwnProperty('loading')) {
    // console.log('protected');
    return <Navigate to="/" replace />
  }

  return children;
};